import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {useQuery} from '@apollo/client';

import HeaderRenderer from '@appComponents/HeaderRenderer';
import {RenderBackToListButton} from '@appComponents/ButtonCollection';
import {createForm, renderModalError} from '@utils/forms';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {GetSpiideoCompetitorMapping} from '@graphql/spiideoCompetitorMapping/query';
import {routes} from '@constants/routes';
import {showModal} from '@utils/modal';

import SpiideoCompetitorMappingForm from '../forms/SpiideoCompetitorMappingForm';
import SpiideoCompetitorMappingModel from '../forms/SpiideoCompetitorMappingModel';

const SpiideoCompetitorMappingEdit = ({
    match: {
        params: {
            id = null,
        },
    },
}) => {
    const isEdit = Boolean(id);
    const isValidEditId = isEdit && isUrlParamValid(id);

    if (isEdit && !isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError(
                'Spiideo competitor mapping',
                routes.spiideoMappings.competitors.path
            ),
        });
    }

    const Form = useMemo(
        () => createForm(
            SpiideoCompetitorMappingModel,
            SpiideoCompetitorMappingForm,
            {id: isEdit ? convertToInt(id) : null}
        ),
        [id]
    );

    const {data, error} = useQuery(GetSpiideoCompetitorMapping, {
        variables: {id},
        skip: !isValidEditId,
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (error) {
            showModal({
                isVisible: true,
                content: renderModalError(
                    'Spiideo competitor mapping',
                    routes.spiideoMappings.competitors.path
                ),
            });
        }
    }, [error]);

    const competitor = data?.spiideoCompetitorMapping?.competitor;
    const pageTitle = isEdit
        ? (competitor ? `Competitor "${competitor.name} (${competitor.id})"` : 'Competitor')
        : 'Add new competitor mapping';

    return (
        <div>
            <HeaderRenderer
                buttons={RenderBackToListButton}
                buttonsProps={{name: 'spiideoMappings.competitors'}}
                messagesBoxNames='spiideoCompetitorMappingError'
                pageTitle={pageTitle}
            />
            <Form />
        </div>
    );
};

SpiideoCompetitorMappingEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }),
};

SpiideoCompetitorMappingEdit.displayName = 'SpiideoCompetitorMappingEdit';

export default withRouter(SpiideoCompetitorMappingEdit);
